<template>
<div>
  <nprogress-container></nprogress-container>
  <div :class="{'nav-open': $sidebar.showSidebar}">

    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</div>
</template>

<script>

 
  import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
 // import { USER_REQUEST } from './store/actions/user'
  export default {
      components:{
    NprogressContainer
  }
  
  }
</script>
<style lang="scss">
.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;
  #nprogress {
    $color: #48e79a;
    .bar {
      background: $color;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }
    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}
  


</style>



// WEBPACK FOOTER //
// src/App.vue